import React from 'react';

export const PageLayout = ({ children, className = "" }) => {
  return (
    <div className={`pt-20 ${className}`}>
      {children}
    </div>
  );
};
